<template lang='pug'>
  .membership-container
    .title(v-text='$t("title")')

    table.levels-table
      tr.tr
        td.td
        td.td
          div(class='svg-icon card-icon dashboard-header-new-white')
        td.td
          div(class='svg-icon card-icon dashboard-header-new-black')
        td.td
          div(class='svg-icon card-icon dashboard-header-new-gold')
      tr.tr(v-for='m in membership')
        td.td(v-text='m.attributes.perk')

        td.td
          .span(v-if='hasPerkText(m.attributes.white)' v-text='m.attributes.white')
          .dot.red-dot(v-else)
        td.td
          .span(v-if='hasPerkText(m.attributes.black)' v-text='m.attributes.black')
          .dot.black-dot(v-else)
        td.td
          .span(v-if='hasPerkText(m.attributes.gold)' v-text='m.attributes.gold')
          .dot.gold-dot(v-else)
</template>

<i18n>
{
  "lng_en": {
    "title": "beauty pass tiers"
  },
  "lng_id": {
    "title": "Tingkatan Beauty Pass"
  },
  "lng_th": {
    "title": "ระดับสมาชิกบิวตี้พาส"
  },
  "lng_zh": {
    "title": "Beauty Pass會籍"
  },
  "lng_ko": {
    "title": "뷰티 패스 등급"
  }
}
</i18n>

<script>
export default {
  props: [
    'membership'
  ],

  methods: {
    hasPerkText (perkValue) {
      return perkValue !== '1'
    }

  }
}
</script>

<style lang='scss' scoped>
  .membership-container {
    padding-bottom: 30px;
    padding-top: 30px;

    @include media-breakpoint-up(xl) {
      margin-left: auto;
      margin-right: auto;
    }

    > .title {
      @include font-sephora-serif;
      font-size: 30px;
      line-height: 32px;
      text-transform: uppercase;
    }

    > .levels-table {
      background: #F4F4F4;
      border: none;
      margin-top: 25px;
      width: 100%;

      @include media-breakpoint-up(xl) {
        width: 880px;
        margin-left: auto;
        margin-right: auto;
      }
    }
  }

  .tr {
    border: none;

    > .td:first-child {
      text-align: left;

      @include media-breakpoint-up(sm) {
        padding-left: 36px;
      }
    }

    > .td:not(:first-child) {
      @include font-weight-medium;
      border-left: 3px solid white;

      @include media-breakpoint-up(lg) {
        width: 140px;
      }
    }
  }

  .td {
    border: none;
    height: 57px;
    padding: 8px;

    > .dot {
      background-color: black;
      border-radius: 50%;
      height: 12px;
      margin: auto;
      width: 12px;
    }

    > .red-dot {
      background-color: $brand-primary;
    }

    > .black-dot {
      background-color: $black;
    }

    > .gold-dot {
      background-color: #c0ae8c;
    }

    > .card-icon {
      height: 34px;
      width: 46px;
      margin-top: 5px;

      @include media-breakpoint-up(sm) {
        height: 70px;
        width: 92px;
      }
    }
  }

  .header-wrapper {
    @include media-breakpoint-up(sm) {
      background-size: cover;
      flex-direction: column;
      height: 170px;
      justify-content: center;
      margin-bottom: 0;
      width: 80%;
      padding: 10px;
    }

    .inner-header {
      @include media-breakpoint-up(sm) {
        bottom: 0;
        width: 566px;
      }
    }
  }

  .dashboard-header-new-white {
    background-image: url('../../../assets/images/icons/beauty-pass-white-tier.png');
  }
  .dashboard-header-new-black {
    background-image: url('../../../assets/images/icons/beauty-pass-black-tier.png');
  }
  .dashboard-header-new-gold {
    background-image: url('../../../assets/images/icons/beauty-pass-gold-tier.png');
  }
</style>
